import Delivery from './Delivery';
import Search from './Search';
import Pickup from './Pickup';
import Settings from './Settings';
import Shelve from './Shelve';

export default {
    Delivery,
    Search,
    Pickup,
    Settings,
    Shelve,
};
